// extracted by mini-css-extract-plugin
module.exports = {"LoginView":"style_LoginView__3HIs5","MiddleRow":"style_MiddleRow__2cSNy"};